<!--
 * @Author: wjc
 * @Date: 2025-06-18 09:09:53
 * @LastEditors: wjc
 * @LastEditTime: 2025-09-30 15:38:25
 * @Description: 
-->
<template>
  <TooltipPortal>
    <TooltipContent
      v-bind="{ ...forwarded, ...$attrs }"
      :class="
        clsx(
          'tooltip-content z-popup text-accent-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 shadow-float bg-popover overflow-hidden rounded-sm px-4 py-2 text-xs',
          props.class
        )
      "
    >
      <slot></slot>
    </TooltipContent>
  </TooltipPortal>
</template>

<script setup lang="ts">
  import type { TooltipContentEmits, TooltipContentProps } from 'reka-ui'

  import { computed } from 'vue'

  import { clsx } from 'clsx'
  import { TooltipContent, TooltipPortal, useForwardPropsEmits } from 'reka-ui'

  defineOptions({
    inheritAttrs: false,
  })

  const props = withDefaults(defineProps<TooltipContentProps & { class?: any }>(), {
    class: '',
    side: 'right',
    sideOffset: 5,
  })

  const emits = defineEmits<TooltipContentEmits>()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })

  const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<style lang="scss">
  .tooltip-content {
    box-shadow:
      0 6px 16px 0 rgb(0 0 0 / 8%),
      0 3px 6px -4px rgb(0 0 0 / 12%),
      0 9px 28px 8px rgb(0 0 0 / 5%);
  }
</style>
